module.exports = __webpack_public_path__ + "img/IC.0630d0cc.png";